function legacy() {

/*  var fname = getUrlParam('fname');
  var lname = getUrlParam('lname');
  var email = getUrlParam('email');
  var code = getUrlParam('code');
  var ig = getUrlParam('ig');

  if ( fname ) { document.getElementById('mce-FNAME').value = fname; }
  if ( lname ) { document.getElementById('mce-LNAME').value = lname; }
  if ( email ) { document.getElementById('mce-EMAIL').value = email; }
  if ( code ) { document.getElementById('mce-PROMOTER').value = code; }
  if ( ig ) { document.getElementById('mce-INSTAGRAM').value = ig; }*/


  if ( !! $('.tickets-list').length ) {
    $('.tickets-list div.ticket:nth-child(4n)').addClass('clear');
  }

  if(!! $('.showclock').length) {
    var clock = new Clock( "#clock-example" );
      $( ".timeshift" ).on('click', function( e ) {
        clock.moveBack( 1 );
        e.preventDefault();
        return false;
    });
  }

  if ( !! $('.stopplay').length ) {

    var started = true;
    var muted = true;

    $('.stopplay').on('click', function() {

      $this = $(this);

      if (started) {

        $this.find('span').addClass('icon-play-1').removeClass('icon-pause-1');
        $this.removeClass('tubular-play').addClass('tubular-pause');
        started = false;

      } else {

        $this.find('span').removeClass('icon-play-1').addClass('icon-pause-1');
        $this.addClass('tubular-play').removeClass('tubular-pause');
        started = true;
      }

    });

    $('.vidmute').on('click', function() {

      $this = $(this);

      if (muted) {

        $this.find('span').removeClass('icon-volume').addClass('icon-volume-off');
        muted = false;

      } else {

        $this.find('span').addClass('icon-volume').removeClass('icon-volume-off');
        muted = true;
      }

    });

  }

    var $theForm = $('#new-contact');

    window.validForm = false;

    window.contactform = {
      params: {
        qname: "UMFSupport",
        account: "NjIxNTA0NTY3ODM4",
        role: "YXJuOmF3czppYW06OjYyMTUwNDU2NzgzODpyb2xlL0NvZ25pdG9fVU1GQ29udGFjdEZvcm1VbmF1dGhfUm9sZQ==",
        identitypool: "dXMtZWFzdC0xOjc2YWJiOGIzLWRlNTctNGVkNi1hZjQ2LTkyMjFlNDhjYjUyMQ=="
      },
      form: 'form#new-contact',
      formdata: {},
      validateFn: function(form){

        if (window.validForm) {
          $(form).serializeArray().map(function(x){ window.contactform.formdata[x.name] = x.value;});
          log(window.contactform.formdata);
        }
        return window.validForm;

      },
      afterSendFn: function(response) {
        // after send to SQS, do ...
        $('#thankyou').removeClass('hide');
        setTimeout(function(){
          $('#new-contact').fadeOut(300);
        }, 2000)
        //log('form hide');
      }
    }

    jQuery(function($) {

      var $theForm = $('#new-contact');

      $theForm.validate({
        rules: {
          "hiddenRecaptcha": {
            required: function() {
              if(grecaptcha.getResponse() == '') {
                //log('yes recaptcha');
                return true;
              } else {
                //log('no recaptcha');
                return false;
              }
            }
          }
        },
        messages: {
          "hiddenRecaptcha": "You must prove you are not a robot",
          "name": "Please enter your Full name",
          "email": "Please enter your Email Address",
          "department": "Please select a Department",
          "subject": "Please enter a Subject"
        },
        invalidHandler: function(event, validator) {
          log('errors');
        },
        submitHandler: function(form) {
          log('no errors');
          $('#new-contact').append('<div class="sending"></div>');
          $('#thankyou').find('span.guest-name').text($('#new-contact input#name').val());
          setTimeout(function() { form.submit(); }, 500);
          return false;
        }
      });

      $('input#preventer').val('34587gh2398sudfv');

    })

}